import { createContentPropTypes } from '../../../helpers/content';

const content = {
	retry: 'Retry',
	errorMessage: 'An error has occurred fetching accounts. Please click button to retry.',
	noMatches: 'No accounts found for the current search criteria',
	noResults: 'No results',
	accountsNoFavouritesText:
		"Make it easy to manage your accounts by selecting your favourites. Choose up to 30 to appear in the 'Favourite accounts' tab by clicking or tapping the stars",
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
